import React from "react";
const phone = require("./images/phone_call.gif");
const response = require("./images/responses.gif");

function Benefits(props) {
  return (
    <div className="my-16 flex flex-col p-4 md:flex-row justify-center max-w-6xl mx-auto gap-3">
      <div className="grid sm:grid-cols-2 rounded-lg shadow-lg">
        <div className="flex justify-center items-center">
          <img fetchpriority="low" src={phone} className="h-90" alt="" />
        </div>
        <div className="flex flex-col items-center justify-center">
          <h2 className="p-5 text-4xl font-bold">Free calls</h2>
          <p className="p-5 text-sm">
            Say goodbye to paying for each client call on other platforms, only
            to find uncertain results. Ditch the Fees and embrace Certainty. We
            believe in a fair game, where you're in control. With us, you
            decide, you deliver, and you get hired on your terms.
          </p>
        </div>
      </div>
      <div className="grid sm:grid-cols-2 mt-5 rounded-lg shadow-lg">
        <div className="flex justify-center items-center">
          <img fetchpriority="low" src={response} className="h-90" alt="" />
        </div>
        <div className="flex flex-col items-center justify-center">
          <h2 className="p-5 text-4xl font-bold">Free responses</h2>
          <p className="p-5 text-sm">
            On some platforms, you pay for every response, with no guarantee of
            client agreement or hiring success. Escape the Costly Guesswork.
            Don't waste your hard-earned money on uncertainty. With us, you only
            pay when the deal is sealed, giving you control and peace of mind.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Benefits;
